/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileZip = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2h10.414L20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4zm11 3.414V7h1.586z" />
        <path d="M11.865 17v-.744l2.291-3.243h-2.21v-.884h3.544v.724l-2.305 3.263h2.392V17zm4.415 0v-4.87h1.045V17zm1.995 0v-4.87h1.742c.599 0 1.05.138 1.353.415.309.276.463.687.463 1.232 0 .54-.154.952-.462 1.233-.304.277-.755.415-1.354.415h-.703V17zm1.528-4.02h-.49v1.595h.49c.357 0 .61-.06.757-.181.152-.125.228-.33.228-.617 0-.29-.076-.495-.228-.616-.148-.12-.4-.181-.757-.181z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileZip as FileZip };
